import { useQuery } from '@tanstack/react-query';
import { documentService } from '@services/document';

export interface UseDocumentsParams {
  projectIds?: string[];
  taskIds?: string[];
  name?: string;
  category?: string;
  page?: number;
  limit?: number;
}

export const DOCUMENTS_QUERY_KEY = 'documents';

// Sprint 43, story-224. `enabled` (default true) lets the CLIENT project page skip the count
// query when the checklist hides the Documents tab. Existing callers are unchanged.
export const useDocuments = (
  params?: UseDocumentsParams,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: [DOCUMENTS_QUERY_KEY, params],
    queryFn: () => documentService.getDocuments(params),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useDocuments;
